<template>
    <component
        ref="CrewAlertsManageCreationChild"
        v-bind:is="child_component"
        :crew_alert="crew_alert"
        :users="users"
        :constants="constants"
        :valuelists="valuelists"
        :is_preview="true"
        :preview_request="preview_request"
        @view="changeView"
        @response-received="submissionResponseReceived"
    />
</template>

<script>
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
    import CrewAlertsCreate from "@/Pages/ExternalPages/CrewAlertsCreate.vue";
    import CrewAlertsShow from "@/Pages/ExternalPages/CrewAlertsShow.vue";

    export default {
        name: "CrewAlertsManageCreation",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        components: {
            CrewAlertsShow,
            CrewAlertsCreate,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                inputs_valid: null,
                crew_alert: null,
                users: null,
                new_file_to_upload: null,
                errors: {},
                child_component:"CrewAlertsCreate",
                preview_request: null,
            }
        },
        computed: {
            alternate_production_name() {
              if (!this.record.production_id) return null
              return this.valuelists.WORKABLE_PRODUCTIONS.find(prod => prod.value === this.record.production_id)?.alt
            },
        },
        methods: {
            changeView (newView) {
                this.child_component = newView
                this.resetValidation()
            },
            resetValidation () {
                this.$refs.CrewAlertsManageCreationChild.resetValidation()
            },
            submissionResponseReceived (response, request_payload) {
                if (!!response.data.users) {
                    this.crew_alert = response.data.crew_alert
                    this.users = response.data.users
                    this.preview_request = request_payload
                    this.changeView("CrewAlertsShow")
                }
            },
        },
    }
</script>

